import { COOKIE_TYPES } from 'hb-react/backoffice/apps/Cookies/constants';
import {
  boCookieList,
  cookieList,
  cookieServiceNameList as cookieServiceNameListDefault,
  boCookieServiceNameList,
} from 'hb-react/shared/apps/CookieBanner/constants/cookies';
import filterListByPropertyAndValues from 'hb-react/shared/utils/filter/filterListByPropertyAndValues';

const byType = (customCookies) => (type) =>
  customCookies.filter(({ cookie_type: cookieType }) => cookieType === type);

const toServiceNameCookie = ({ name, version }) => ({
  name: `${name}_${version}`,
  accepted: true,
});

const getCookies = ({
  env,
  paymentMethod,
  hasPaymentAccount,
  amplitudeIsEnabled,
  linkedInIsEnabled = true,
  twitterIsEnabled = true,
  facebookIsEnabled = true,
  flagActivateFrontMonitoringDatadog = false,
  flagAxpPlanhatIntegration = false,
  flagTtPoRemoveUserSessionCookie = false,
  flagUeNewOutdatedBrowserDetection = false,
  hasGoogleAnalyticsTracking = true,
  customCookies = [],
}) => {
  const values = [];

  if (hasPaymentAccount === false) {
    values.push('Paypal', 'Stripe', 'Braintree');
  }
  if (paymentMethod === 'Stripe' && hasPaymentAccount) {
    values.push('Paypal', 'Braintree');
  }
  if (paymentMethod === 'Paypal' && hasPaymentAccount) {
    values.push('Stripe', 'Braintree');
  }
  if (paymentMethod === 'Braintree' && hasPaymentAccount) {
    values.push('Stripe', 'Paypal');
  }
  if (amplitudeIsEnabled === false) {
    values.push('Amplitude (Trackers)');
  }
  if (linkedInIsEnabled === false) {
    values.push('LinkedIn');
  }
  if (twitterIsEnabled === false) {
    values.push('Twitter');
  }
  if (facebookIsEnabled === false) {
    values.push('Facebook');
  }
  if (hasGoogleAnalyticsTracking === false) {
    values.push('Google analytics');
  }
  if (flagActivateFrontMonitoringDatadog === false) {
    values.push('Datadog');
  }
  if (flagTtPoRemoveUserSessionCookie === false) {
    values.push('Hivebrite (flagTtPoRemoveUserSessionCookie)');
  }
  if (flagUeNewOutdatedBrowserDetection === false) {
    values.push('Hivebrite (flagUeNewOutdatedBrowserDetection)');
  }
  if (flagAxpPlanhatIntegration === false) {
    values.push('Planhat NPS');
  }

  const getCookiesByType = byType(customCookies);

  const customFunctional = getCookiesByType(COOKIE_TYPES.FUNCTIONAL);
  const customTracking = getCookiesByType(COOKIE_TYPES.TRACKING);
  const customRequired = getCookiesByType(COOKIE_TYPES.REQUIRED);

  const cookieListTemp = {
    functional: [
      ...filterListByPropertyAndValues(
        cookieList.functional,
        'service_name',
        values,
      ),
      ...customFunctional,
    ],
    required: [
      ...filterListByPropertyAndValues(
        cookieList.required,
        'service_name',
        values,
      ),
      ...customRequired,
    ],
    tracking: [
      ...filterListByPropertyAndValues(
        cookieList.tracking,
        'service_name',
        values,
      ),
      ...customTracking,
    ],
  };

  const cookieServiceNameListTemp = {
    functional: [
      ...filterListByPropertyAndValues(
        cookieServiceNameListDefault.functional,
        'name',
        values,
      ),
      ...customFunctional.map(toServiceNameCookie),
    ],
    required: [
      ...filterListByPropertyAndValues(
        cookieServiceNameListDefault.required,
        'name',
        values,
      ),
      ...customRequired.map(toServiceNameCookie),
    ],
    tracking: [
      ...filterListByPropertyAndValues(
        cookieServiceNameListDefault.tracking,
        'name',
        values,
      ),
      ...customTracking.map(toServiceNameCookie),
    ],
  };

  switch (env) {
    case 'po':
    case 'fo':
      return {
        cookieList: cookieListTemp,
        cookieServiceNameList: cookieServiceNameListTemp,
      };
    case 'bo':
      return {
        cookieServiceNameList: {
          ...boCookieServiceNameList,
          required: [
            ...filterListByPropertyAndValues(
              boCookieServiceNameList.required,
              'name',
              values,
            ),
            ...customRequired.map(toServiceNameCookie),
          ],
        },

        cookieList: {
          ...boCookieList,
          required: filterListByPropertyAndValues(
            boCookieList.required,
            'service_name',
            values,
          ),
        },
      };
    default:
      return null;
  }
};

export default getCookies;
